import React from "react";
import Navbar from "../components/layout/header/Navbar";
import Layout from "../components/layout/Layout";
import PageHeader from "../components/team/PageHeader";
import Footer from "../components/layout/footer/Footer";
import CabeceraRamallo from "../components/destinosSecciones/CabeceraRamallo";
import HoteleriaRamallo from "../components/hoteleria/HoteleriaRamallo";
import TransporteTerrestre from "../components/Transporte/TransporteTerrestre";
import VideoPromoDestino from "../components/promo/VideoPromoDestino";
import DiversionRamallo from "../components/diversion/DiversionRamallo";
import AsistenciaMedica from "../components/AsistenciaMedica/AsistenciaMedica";

export default function PriRamallo() {
  return (
    <Layout>
    <Navbar darkBg />
    <PageHeader
      background={"assets/img/ramallo/banner-ramallo.jpg"}
      HeaderTitle="Ramallo"
      Parent="primarios"
      PageTitle="Ramallo"
    />
    <CabeceraRamallo destino={"Ramallo"} />
    <VideoPromoDestino
      background="assets/img/ramallo/banner-ramallo.jpg"
      YoutubeVideoId="QbCLavd9uWo"
      TextoPromo="Conoce Ramallo, tu viaje de egresados."
    />
    <HoteleriaRamallo />
    <DiversionRamallo hasBg={true} />
    <TransporteTerrestre />
    <AsistenciaMedica bgColor />
    <Footer />
  </Layout>
  );
}